import { Controller } from "stimulus";

export default class extends Controller {
  format(event) {
    event.target.value = event.target.value.replace(/ /g, "_").toLowerCase();
  }
}